export const LINK_FIELD = `
linkField {
  url
  title
  class
}
`

export const LINK_TITLE = `
linkTitle {
  url
  title
  class
}
`

export const BUTTON = `
button {
  url
  title
}
`

export const BUTTON_SETTINGS = `
buttonSettings {
  popupEnabled
  linkType
  linkSize
  linkIcon
}
`

export const BUTTON_SETTINGS_2 = `
buttonSettings2 {
  popupEnabled
  linkType
  linkSize
  linkIcon
}
`
